import { useState } from 'react';
import { DocumentsPage } from './DocumentsPage';
import { EmployeePaySummaryPage } from './EmployeePaySummaryPage';
import { PayrollRegisterPage } from './PayrollRegisterPage';

const TABS = [
  { key: 'register', label: 'Payroll Register & Cash Requirement' },
  { key: 'pay-summary', label: 'Employee Pay Summary' },
  { key: 'documents', label: 'Documents' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

/** A single primaryNav entry ("Reports & Documents," promoted from two separate comingLaterNav
 * placeholders) fronting three pages — mirrors Module 11's own precedent of combining related
 * sub-features (GL Mappings + GL Exports) under one nav entry with tabs. */
export function ReportsDocumentsPage() {
  const [tab, setTab] = useState<TabKey>('register');

  return (
    <div>
      <div className="tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={tab === t.key ? 'tab tab--active' : 'tab'}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'register' && <PayrollRegisterPage />}
      {tab === 'pay-summary' && <EmployeePaySummaryPage />}
      {tab === 'documents' && <DocumentsPage />}
    </div>
  );
}
